import { useTranslation } from 'react-i18next';

import { LuMoon, LuSun } from 'react-icons/lu';

import { Theme, useTheme } from '../../context/ThemeContext';

const stylesheet = {
  wrapper: 'absolute top-6 right-6',
  pillTrack:
    'inline-flex items-center gap-0.5 rounded-full border border-semantic-border bg-semantic-surface-2 p-[3px]',
  pillButtonActive:
    'w-9 h-8 rounded-full grid place-items-center transition bg-semantic-bg-surface shadow-sm text-semantic-emerald',
  pillButtonInactive:
    'w-9 h-8 rounded-full grid place-items-center transition bg-transparent text-semantic-text-tertiary',
};

interface AuthThemeToggleProps {
  className?: string;
}

export function AuthThemeToggle({ className }: Readonly<AuthThemeToggleProps>) {
  const { t } = useTranslation();
  const { theme, setTheme } = useTheme();

  const isDark = theme === Theme.DARK;
  const labelLight = t('auth.theme.light');
  const labelDark = t('auth.theme.dark');

  return (
    <div className={className ?? stylesheet.wrapper}>
      <div className={stylesheet.pillTrack}>
        <button
          type="button"
          aria-pressed={!isDark}
          aria-label={labelLight}
          className={
            isDark ? stylesheet.pillButtonInactive : stylesheet.pillButtonActive
          }
          onClick={() => setTheme(Theme.LIGHT)}
        >
          <LuSun />
        </button>
        <button
          type="button"
          aria-pressed={isDark}
          aria-label={labelDark}
          className={
            isDark ? stylesheet.pillButtonActive : stylesheet.pillButtonInactive
          }
          onClick={() => setTheme(Theme.DARK)}
        >
          <LuMoon />
        </button>
      </div>
    </div>
  );
}
